<template>
  <div
    :class="['header', obsMessage ? 'headerlargeheight' : '']"
    :style="bgc"
  >
    <b-col>
      <b-row class="topheader-container">
        <h5 class="application-sub-heading">
          <p
            :v-show="applicationSubHeading.length > 0"
            class="applicationSubHeading"
          >
            {{ applicationSubHeading }}
          </p>
        </h5>
        <div class="topheader">
          <div
            id="logo"
            class="top-header-left-flex"
          >
            <img
              src="../../../assets/images/mms_logo_white.svg"
              alt=""
            >
            <h1 class="env-text">
              {{ environment }}
            </h1>
          </div>
          <div class="top-header-middle">
            <div class="text-white webtools-horizontal">
              <a
                :href="this.config_LinkTvAnalys"
                class="webtool"
              >
                <div class="webtool-icon-container">
                  <img
                    class="webtool-icon"
                    src="../../../assets/images/tv.svg"
                    alt=""
                  >
                </div>
                <div class="webtool-text-container">
                  <p>TV-Analys</p>
                </div>
                <div class="nav-selection-underline" />
              </a>
              <a class="webtool">
                <div class="webtool-icon-container">
                  <img
                    class="webtool-icon"
                    src="../../../assets/images/online.svg"
                    alt=""
                  >
                </div>
                <div class="webtool-text-container">
                  <p style="user-select: none;">Online-Analys</p>
                </div>
                <div class="nav-selection-underline-static" />
              </a>
              <a
                :href="this.config_LinkTotalanalys"
                class="webtool"
              >
                <div class="webtool-icon-container">
                  <img
                    class="webtool-icon"
                    src="../../../assets/images/total.svg"
                    alt=""
                  >
                </div>
                <div class="webtool-text-container">
                  <p>Totalanalys</p>
                </div>
                <div class="nav-selection-underline" />
              </a>
              <a
                :href="this.config_LinkDataPortal"
                class="webtool"
              >
                <div class="webtool-icon-container">
                  <img
                    class="webtool-icon"
                    src="../../../assets/images/home.svg"
                    alt=""
                  >
                </div>
                <div class="webtool-text-container">
                  <p>Portalen</p>
                </div>
                <div class="nav-selection-underline" />
              </a>
            </div>
          </div>
          <div class="top-header-right-flex contextmenu-container">
            <div class="webtools-dropdown-container">
              <b-dropdown
                id="dropdown-3"
                text="Fler Webbverktyg"
                class="webtools-dropdown"
              >
                <b-dropdown-item :href="this.config_LinkTvAnalys">
                  <img
                    class="webtool-icon-dropdown"
                    src="../../../assets/images/tv-blue.svg"
                    alt=""
                  >TV-Analys
                </b-dropdown-item>
                <b-dropdown-item active>
                  <img
                    class="webtool-icon-dropdown"
                    src="../../../assets/images/online.svg"
                    alt=""
                  >Online-Analys
                </b-dropdown-item>
                <b-dropdown-item :href="this.config_LinkTotalanalys">
                  <img
                    class="webtool-icon-dropdown"
                    src="../../../assets/images/total-blue.svg"
                    alt=""
                  >Totalanalys
                </b-dropdown-item>
                <b-dropdown-divider />
                <b-dropdown-item :href="this.config_LinkDataPortal">
                  <img
                    class="webtool-icon-dropdown"
                    src="../../../assets/images/home-blue.svg"
                    alt=""
                  >Portalen
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <b-dropdown
              id="dropdown-1"
              split
              :text="this.$store.getters.getUser"
              class="contextmenu-login"
            >
              <b-dropdown-item @click="logout">
                Logga ut
              </b-dropdown-item>
              <b-dropdown
                id="dropdown-2"
                offset="-45"
                text="Rensa Cache"
                class="mr-2 contextmenudd2"
              >
                <b-dropdown-item @click="onClick('Rensa allt')">
                  Rensa allt
                </b-dropdown-item>
                <b-dropdown-divider />
                <p>PROGRAM</p>
                <b-dropdown-divider />
                <b-dropdown-item @click="onClick('Rensa kolumnval')">
                  Rensa kolumnval
                </b-dropdown-item>
                <b-dropdown-item @click="onClick('Rensa Målgruppsväljaren')">
                  Rensa målgruppsväljaren
                </b-dropdown-item>
                <b-dropdown-item @click="onClick('Rensa Genreväljaren')">
                  Rensa genreväljaren
                </b-dropdown-item>
                <b-dropdown-divider />
                <p>SITE</p>
                <b-dropdown-divider />
                <b-dropdown-item @click="onClick('Rensa Målgruppsväljaren Site')">
                  Rensa målgruppsväljaren site
                </b-dropdown-item>
              </b-dropdown>
            </b-dropdown>
          </div>
        </div>
        <div />
      </b-row>
      <b-row
        v-if="obsMessage"
        class="bottomheader"
      >
        <p class="topBtns obsText">
          {{ obsMessage }}
        </p>
      </b-row>
    </b-col>

    <b-sidebar
      id="sidebar-1"
      right
      title="Informationslogg"
      shadow
    >
      <div class="px-3 py-2">
        <p class="messageBox">
          {{ dataLogMessage }}
        </p>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { dateToyymmddFormat } from '../../../assets/js/utils.js';
import { dateToTimeStamp } from '../../../assets/js/utils.js';
import { fetchFormFieldData } from '../../../assets/js/api.js';
import globalConfig from "@/mixins/globalConfig";

export default {
  name: 'PageHeader',
  mixins: [globalConfig],
  data() {
    return {
      info: 'You are have been login and this is Home Page',
      applicationSubHeading: '',
      obsMessage: '',
      dataLogMessage: '',
      SSASMessage: {
        linkedSSAS: '',
        version: '',
        lastImported: '',
        lastProcessed: '',
        latestDay: '',
        publishedToDate: '',
        publishedFromDate: '',
      },
    };
  },
  computed: {
    bgc() {
      return {
        'background-color': this.config_BackgroundColor,
      };
    },
    environment() {
      const heading = (this.config_ApplicationHeading || "").toLowerCase();
      if (heading.includes(" dev")) {
        return "DEV";
      } else if (heading.includes(" test")) {
        return "TEST";
      } else if (heading.includes(" local")) {
        return "LOCAL";
      }
      return "";
    }
  },
  async mounted() {
    this.applicationSubHeading = this.config_ApplicationSubHeading;
    this.$root.$on('bv::dropdown::show', (bvEvent) => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on('bv::dropdown::hide', (bvEvent) => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = false;
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
  },
  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let token = urlParams.get("token");
    let user = urlParams.get("user");

    if (token === null) {
      token = localStorage.getItem("accessToken", token);
      user = localStorage.getItem("user", user);
    }

    localStorage.setItem("accessToken", token);
    localStorage.setItem("user", user);

    this.$store.commit("setLoggedIn", true);
    this.$store.commit("setUser", user);
    this.$store.commit("setAccessToken", token);
    await fetchFormFieldData("User")
      .then(user => {
        localStorage.setItem("user", user.email);
        this.$store.commit("setUser", user.email);
        for (let i = 0; i < user.applications.length; i++) {
          if (user.applications[i].applicationName == "online-analys") {
            this.$store.commit('systemInfo/updateFullAccess', true);
          }
          if (user.applications[i].applicationName == "online-analys-light") {
            this.$store.commit('systemInfo/updateLightAccess', true);
          }
          if (user.applications[i].applicationName == "online-analys-annonsör") {
            this.$store.commit('systemInfo/updateAdvertiserAccess', true);
          }
        }
      })
      .catch(error => {
        if (error.response?.status != 401)
          this.toastMessage(
            "Problem uppstod vid hämtning av användare.",
            false
          );
        console.error(error);
      });

    //Fetch Message from api
      try {
        let messages = await fetchFormFieldData('Message')
        this.obsMessage = messages.obsMessage;
        this.dataLogMessage = messages.dataLogMessage;
      } catch (error) {
        if (error.response?.status != 401)
          this.toastMessage('Problem uppstod vid hämtning av meddelanden.', false);
        console.error(error);
      }
     
    //Fetch Version from api
    await fetchFormFieldData('Information')
      .then((information) => {
        if (information.statusCode) {
          this.$bvToast.toast(information.errorMessage, {
            title: 'Varning',
            variant: 'warning',
            solid: true,
            autoHideDelay: 3000,
          });
        } else {
          this.SSASMessage.linkedSSAS = information.linkedSSAS;
          this.SSASMessage.version = information.version;
          this.SSASMessage.lastImported =
            dateToyymmddFormat(information.lastImported.replace(/-/g, '/')) +
            ' ' +
            dateToTimeStamp(information.lastImported.replace(/-/g, '/'));
          this.SSASMessage.lastProcessed =
            dateToyymmddFormat(information.lastProcessed.replace(/-/g, '/')) +
            ' ' +
            dateToTimeStamp(information.lastProcessed.replace(/-/g, '/'));
          this.SSASMessage.latestDay = dateToyymmddFormat(information.latestDay.replace(/-/g, '/'));
          this.SSASMessage.publishedFromDate = dateToyymmddFormat(information.publishedFromDate);
          this.SSASMessage.publishedToDate = dateToyymmddFormat(information.publishedToDate);
          this.SSASMessage.adPublishedFromDate = dateToyymmddFormat(
            information.adPublishedFromDate,
          );
          
          this.$store.commit(
            'systemInfo/updateSSASInfo',
            this.SSASMessage,
          );
          this.$store.commit(
            'systemInfo/updateExcelExportFilePreName',
            information.excelExportFilePreName,
          );
          this.$store.commit(
            'systemInfo/updateExcelExportTextInFile',
            information.excelExportTextInFile,
          );

          this.$store.commit(
            'systemInfo/updatePublishedFromDate',
            dateToyymmddFormat(information.publishedFromDate),
          );
          this.$store.commit(
            'systemInfo/updatePublishedToDate',
            dateToyymmddFormat(information.publishedToDate),
          );
          this.$store.commit(
            'systemInfo/updateAdPublishedFromDate',
            dateToyymmddFormat(information.adPublishedFromDate),
          );
        }
      })
      .catch((error) => {
        if (error.response?.status != 401)
          this.toastMessage(
            'Problem att hämta standarddatum från servern. Tjänsten kommer inte fungera korrekt.',
            true,
          );
        console.error(error);
      });
  },
  methods: {
    toastMessage(message, closeButton) {
      if (closeButton) {
        const h = this.$createElement;

        const vNodesMsg = h('b', { class: ['text-center', 'mb-0'] }, [
          message,
          h(
            'b-button',
            {
              class: ['float-right', 'btn-sm', 'mr-3'],
              on: {
                click: () => this.$bvToast.hide('toast'),
              },
            },
            'Stäng',
          ),
        ]);

        this.$bvToast.toast([vNodesMsg], {
          id: 'toast',
          title: 'Varning',
          variant: 'danger',
          solid: true,
          noAutoHide: true,
        });
      } else {
        this.$bvToast.toast(message, {
          title: 'Varning',
          variant: 'warning',
          solid: true,
        });
      }
    },
    async logout() {
      await this.$store.dispatch("logout");
      window.location.href = this.config_WebCaatAuthWebUrl
    },
    onClick(text) {
      if (text == 'Rensa allt') {
        this.RemoveLocalStorageTargetGroups();
        localStorage.removeItem('columnsSelected');
        localStorage.removeItem('columnsSelectedCampaign');
        localStorage.removeItem('savedFilmCodes');
        localStorage.removeItem('genreConfigs');
        localStorage.removeItem('measuresSite');
        location.reload();
      } else if (text == 'Rensa kolumnval') {
        localStorage.removeItem('columnsSelected');
        localStorage.removeItem('columnsSelectedCampaign');
        location.reload();
      } else if (text == 'Rensa Målgruppsväljaren') {
        this.RemoveLocalStorageTargetGroups();
        location.reload();
      } else if (text == 'Rensa Målgruppsväljaren Site') {
        localStorage.removeItem('measuresSite');
        location.reload();
      } else if (text == 'Rensa Genreväljaren') {
        localStorage.removeItem('genreConfigs');
        location.reload();
      }
    },
    RemoveLocalStorageTargetGroups() {
      localStorage.removeItem('measures');
      localStorage.removeItem('reachHeaders');
      localStorage.removeItem('reachMeasures');
      localStorage.removeItem('campaignMeasures');
    },
  },
};
</script>

<style scoped>
.env-text {
    color: #fff;
    padding: 10px 0 0 0;
    margin-left: 1rem;
}
.header {
  background-color: #337ab7;
}
.headerlargeheight {
  height: 110px;
}
.topheader-container {
  height: 70px;
  padding: 0 20px;
  align-content: center;
}
.topheader {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.application-sub-heading {
  position: absolute;
  top: 52px;
}
.top-header-left-flex {
  width: 45%;
  display: flex;
  justify-content: flex-start;
  align-content: center;
}
.top-header-right-flex {
  width: 45%;
  display: flex;
  justify-content: flex-end;
}
.top-header-middle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 500px;
}
.bottomheader {
  background-color: white;
  height: 39px;
  padding: 5px;
  padding-left: 16px;
  display: flex;
  justify-content: center;
  align-content: center;
}
.top-header-left-flex img {
  width: 8em;
}
.header p,
.header a {
  color: white;
  margin-bottom: 0;
}
.informationlogtext {
  font-size: 0.8em;
}
.topBtns {
  float: right;
  color: white;
}
.helpIcon {
  margin-bottom: 10px;
}

.obsText {
  color: #ff8c00 !important;
  font-size: 0.9em;
  align-self: center;
}
.messageBox {
  border: 1px solid #dee2e6 !important;
  background-color: #eee;
  margin-bottom: 0;
  padding: 10px;
  font-size: small;
  color: #2c3e50 !important;
  text-align: left;
  white-space: pre-line;
}
.applicationSubHeading {
  font-size: small;
  color: white !important;
  -webkit-text-stroke: 0.04em red;
  font-weight: bold;
}
.right {
  position: absolute;
  right: 10px;
}
.v-context a {
  color: #495057;
}
</style>
<style>
.closebtn {
  position: absolute;
  right: 0;
  bottom: 0;
}
.infoTooltip .tooltip-inner {
  font-size: smaller;
  text-align: left;
  max-width: 300px;
}
.contextmenu-login > button:first-child:hover {
  border-color: #6c757d;
  cursor: default;
}
.top-header-right-flex button {
  background-color: inherit !important;
  /* border: none; */
}
#dropdown-1 {
  max-height: 70px;
  align-self: center;
}
.webtools-dropdown-container {
  border: none !important;
  margin: 0;
  padding: 0;
}
.webtools-dropdown button {
  border: none !important;
  border-color: transparent !important;
  padding-left: 1rem;
}
.webtools-dropdown ul {
  font-size: 0.8rem;
}
.webtool a {
  font-size: 0.8rem;
  white-space: nowrap;
  align-self: center;
}
.webtool p {
  font-size: 0.8rem;
  white-space: nowrap;
  align-self: center;
  margin-top: 0.2rem;
}
.this-tool-container {
  position: relative;
  padding: 0;
  margin-right: 3rem;
  align-self: center;
  display: inline-flex;
  align-content: center;
}
.this-tool-text-container p {
  color: #337ab7 !important;
  font-weight: 500;
  font-size: 1rem;
  padding: 0;
  height: 100%;
  margin-top: 0.2rem;
}
.webtool:hover {
  text-decoration: none;
}
.webtool-icon-container {
  flex: 1;
  height: 100%;
  width: 2rem;
  margin-right: 0rem;
}
.this-tool-icon-container {
  flex: 1;
  height: 100%;
  width: 2.4rem;
  margin-top: 0rem;
}
.webtool-icon-container img {
  max-width: 1.5rem;
  max-height: 1.5rem;
}
.this-tool-icon-container {
  max-width: 2.5rem;
  max-height: 2.5rem;
}
.webtool-text-container {
  flex: 1;
  text-align: center;
  margin-top: 0.2rem;
}
.nav-selection-underline-static {
  position: absolute;
  width: 115%;
  bottom: -0.5rem;
  transform: translateX(-5%);
  border-bottom: white 1px solid;
}
.nav-selection-underline {
  transition: background-color 100ms ease-in-out;
  background-color: transparent;
}
.webtool:hover .nav-selection-underline {
  position: absolute;
  width: 115%;
  bottom: -0.6rem;
  transform: translateX(-5%);
  height: 2.8rem;
  background-color: #19508131;
  z-index: -1;
  border-radius: 5%;
}
.webtool-icon-dropdown {
  max-width: 1.5rem;
  max-height: 1.5rem;
  margin-right: 0.8rem;
  margin-bottom: 0.15rem;
}
img.this-tool-icon {
  max-width: 1.5rem;
  max-height: 1.5rem;
  margin-left: 0.2rem;
  margin-right: 0.4rem;
  padding: 0;
}
#dropdown-3 {
  display: none;
}
.webtool {
  position: relative;
  margin: 0;
  padding: 0;
  align-self: center;
  display: inline-flex;
  align-content: center;
}
.webtools-horizontal {
  display: flex;
  justify-content: space-between;
  align-self: center;
  padding: 0;
  margin: 0;
  height: 38px;
  width: 100%;
}
.webtool-icon-container {
  flex: 1;
  height: 100%;
}
.manual-button {
  display: inline-flex !important;
  align-content: center;
}
.manual-button .b-icon {
  flex: 1;
}
.manual-button span {
  flex: 1;
  padding-left: 0.5rem;
  font-size: 0.7rem !important;
  align-self: center;
}
.contextmenudd2 button:active {
  background-color: #337ab7 !important;
  color: #fff !important;
}
.contextmenudd2 ul p {
  padding: 0.25rem 1.5rem;
  color: #212529 !important;
}
.contextmenudd2 button {
  color: #212529 !important;
  width: 241px;
  border: none;
  text-align: left;
  border-radius: 0px;
  padding: 0.25rem 1.5rem;
}
.contextmenudd2 button:hover {
  color: #16181b !important;
  text-decoration: none;
  background-color: #f8f9fa !important;
}
@media (max-width: 639px) {
  .webtools-horizontal {
    display: none;
  }
}
@media (min-width: 640px) and (max-width: 1200px) {
  #dropdown-3 {
    display: block;
  }
  .webtools-horizontal {
    display: none;
  }
}
</style>
